import humps from 'humps';
import request from '../request';


// templates
let id = '';
let firstName = '';
let lastName = '';
let username = '';
let email = '';
let userType = 'user';
const password = '';
const newPassword = '';
const confirmNewPassword = '';
let hasAcceptedTerms = false;

if (localStorage.getItem('user') !== null) {
  const localUserStr = localStorage.getItem('user');
  if (typeof localUserStr !== 'undefined' && localUserStr !== 'undefined') {
    try {
      const storedUser = humps.camelizeKeys(JSON.parse(localUserStr));
      id = storedUser.id;
      firstName = storedUser.firstName;
      lastName = storedUser.lastName;
      username = storedUser.username;
      email = storedUser.email;
      userType = storedUser.type;
      hasAcceptedTerms = storedUser.hasAcceptedTerms;
    } catch (e) {
      console.log(e); // eslint-disable-line
    }
  }
}

export default {
  namespaced: true,
  state: {
    data: {
      id,
      firstName,
      lastName,
      username,
      email,
      password,
      newPassword,
      confirmNewPassword,
      type: userType,
      hasAcceptedTerms,
    },
    form: {
      firstName,
      lastName,
      username,
      email,
      password,
      newPassword,
      confirmNewPassword,
      hasAcceptedTerms,
    },
    formErrors: {},
    formSaved: false,
  },
  mutations: {
    set(state, payload) {
      const user = humps.camelizeKeys(payload);
      Object.assign(state.data, { id: user.id });
      Object.assign(state.data, { firstName: user.firstName });
      Object.assign(state.data, { lastName: user.lastName });
      Object.assign(state.data, { username: user.username });
      Object.assign(state.data, { email: user.email });
      Object.assign(state.data, { type: user.type });
      Object.assign(state.data, { hasAcceptedTerms: user.hasAcceptedTerms });

      Object.assign(state.form, { firstName: user.firstName });
      Object.assign(state.form, { lastName: user.lastName });
      Object.assign(state.form, { username: user.username });
      Object.assign(state.form, { email: user.email });
      Object.assign(state.form, { hasAcceptedTerms: user.hasAcceptedTerms });
    },
    setFormValue(state, { field, value }) {
      Object.assign(state.form, { [field]: value });
    },
    setErrors(state, serverFormErrors) {
      Object.assign(state, { formErrors: [] });
      const formErrors = humps.camelizeKeys(serverFormErrors);
      Object.assign(state, { formErrors });
    },
    setFormSaved(state, formSaved) {
      Object.assign(state, { formSaved });
    },
    setUserFromForm(state) {
      Object.assign(state.data, { username: state.form.username });
      Object.assign(state.data, { email: state.form.email });
      Object.assign(state.data, { hasAcceptedTerms: state.form.hasAcceptedTerms });

      localStorage.setItem('user', JSON.stringify(humps.decamelizeKeys(state.data)));
    },
  },
  actions: {
    get() {

    },
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
    signup(context, payload) {
      const URL = `${process.env.API_URL}auth/signup`;

      const data = {
        type: payload.type,
        email: context.state.form.email,
        username: context.state.form.username,
        password: context.state.form.newPassword,
        password_confirmation: context.state.form.confirmNewPassword,
        language: context.rootState.language,
      };
      if (payload.type === 'promoter') {
        data.company_name = context.rootState.promoter.form.companyName;
        data.rnaat_number = context.rootState.promoter.form.rnaatNumber;
        data.has_accepted_terms = false;
      }
      if (payload.type === 'user') {
        data.first_name = context.state.form.firstName;
        data.last_name = context.state.form.lastName;
        data.has_accepted_terms = context.state.form.hasAcceptedTerms;
      }
      if (typeof payload !== 'undefined') {
        if (typeof payload.validateOnly !== 'undefined') {
          data.validateOnly = payload.validateOnly;
        }
      }
      context.commit('setErrors', []);
      request.make({
        type: 'POST',
        url: URL,
        data,
      }, (err, res) => {
        if (!data.validateOnly) {
          context.commit('setShowAllValidationErrors', true, { root: true });
        }
        if (res.status === 422) {
          context.commit('setErrors', res.body.errors);
          context.commit('promoter/setErrors', res.body.errors, { root: true });
        }
        if (res.status === 201 || res.status === 200) {
          context.commit('setErrors', []);
          if (!data.validateOnly) {
            if (payload.type === 'user') {
              window.vue.$router.push(`/${context.rootState.language}/registrationSuccess`);
            } else {
              window.vue.$router.push(`/${context.rootState.language}/PromoterRegistrationSuccess`);
            }
          }
        }
      });
    },
    save(context, payload) {
      return new Promise((resolve) => {
        const data = {
          username: context.state.form.username,
          first_name: context.state.form.firstName,
          last_name: context.state.form.lastName,
          email: context.state.form.email,
          has_accepted_terms: context.state.form.hasAcceptedTerms,
          type: context.state.data.type,
        };
        if (context.state.form.password !== '') {
          data.old_password = context.state.form.password;
        }
        if (context.state.form.newPassword !== '') {
          data.password = context.state.form.newPassword;
        }
        if (context.state.form.confirmNewPassword !== '') {
          data.password_confirmation = context.state.form.confirmNewPassword;
        }
        if (typeof payload !== 'undefined') {
          if (payload.validateOnly) {
            data.validateOnly = true;
          }
        }
        request.make({
          type: 'PUT',
          url: `${process.env.API_URL}user`,
          data,
        }, (err, res) => {
          if (!data.validateOnly) {
            context.commit('setShowAllValidationErrors', true, { root: true });
          }
          if (res.status === 204 || res.status === 200) {
            if (!data.validateOnly) {
              context.commit('setFormSaved', true);
              context.commit('setUserFromForm');
            }
            context.commit('setErrors', {});
            resolve();
          } else if (res.status === 422) {
            context.commit('setFormSaved', false);
            context.commit('setErrors', res.body.errors);
            if (!data.validateOnly) {
              context.dispatch('showSaveError', undefined, { root: true });
            }
            // reject();
          }
        });
      });
    },
    validate(context) {
      context.dispatch('save', { validateOnly: true });
    },
    validateSignup(context, payload) {
      Object.assign(payload, { validateOnly: true });
      context.dispatch('signup', payload);
    },
    setFormSaved(context, payload) {
      context.commit('setFormSaved', payload);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/user.js